module.exports = __webpack_public_path__ + "static/media/inv-glider4.722ba999.svg";